import React, { useEffect, useLayoutEffect } from "react";

import ParseContent from "@molecules/ParseContent";

import useStoreInfo from "@queries/useStoreInfo";

export default function TermsAndConditions() {
  const { fetchShopData, shopData } = useStoreInfo();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    void fetchShopData();
  }, []);

  return (
    <section className="pc:gap-10 col-span-8 flex h-fit flex-col gap-5 wrap-break-word">
      <h2 className="text-title pc:flex hidden">Terms and Conditions</h2>
      <ParseContent html={shopData?.shop.termsOfService?.body || ""} />
    </section>
  );
}
